import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Loader from "../../components/loader";
import { useNCallContext } from "../../context/ncall-context";
import http from "../../service/http";
import { localStorageSetter } from "../../utils/localStorageHelper";
import { showErrorToast } from "../../utils/toast";

const LoginClient = () => {
  const { state, code, setCode, dispatch } = useNCallContext();

  const navigate = useNavigate();

  const handleClientCodeSubmit = async (e) => {
    e.preventDefault();

    try {
      dispatch({ type: "LOADING", payload: true });

      const res = await http.post(`/companies`, { code });
      const client = await res.data;

      if (client.error) {
        showErrorToast("Something went wrong!");
      } else {
        localStorageSetter({
          "logged-in-as": "client",
          "code": code,
          "companyName": client?.data.companyName,
          "clientId": client?.data.ncall_ClientId,
          "companyId": client?.data.id,
        });

        dispatch({
          type: "ADD-CLIENT",
          payload: { client: client.data },
        });

        navigate("/client", { replace: true });
      }
    } catch (error) {
      showErrorToast(error.response.data.message);
    } finally {
      dispatch({ type: "LOADING", payload: false });
      setCode("");
    }
  };

  useEffect(() => {
    if (localStorage.getItem("logged-in-as")) {
      if (localStorage.getItem("logged-in-as") === "client") {
        navigate(`/client`);
      } else if (localStorage.getItem("logged-in-as") === "admin") {
        navigate(`/admin`);
      }
    }
  }, []);

  if (state.loading) {
    return <Loader />;
  }

  return (
    <div className=" bg-slate-100 h-screen ">
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md flex">
          <h3 className="mt-6 text-center text-2xl  font-bold tracking-tight text-indigo-500">
            Thunder Bay Answering Service - <br /> Client Schedule Login
          </h3>
          <img
            src={require("../../assets/happy face logo.jpg")}
            alt="Happy face"
          />
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <form className="space-y-6" onSubmit={handleClientCodeSubmit}>
              <div>
                <label
                  htmlFor="client-code"
                  className="block text-sm font-medium text-gray-700"
                >
                  Client Code
                </label>
                <div className="mt-1">
                  <input
                    id="client-code"
                    type="text"
                    autoComplete="text"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    required
                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  />
                </div>
              </div>
              {/* <button
                onClick={() => navigate("/admin-login", { replace: true })}
                className=" text-indigo-500 font-bold underline"
              >
                Login As Admin
              </button> */}
              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span>Get Client</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default LoginClient;
